export const transactions = [
  { id: 1, title: "Apple Store", date: "Today, 4:20 PM", amount: -1299.00, type: "expense", category: "Tech" },
  { id: 2, title: "Freelance Client", date: "Today, 10:00 AM", amount: 3500.00, type: "income", category: "Business" },
  { id: 3, title: "Uber Ride", date: "Yesterday", amount: -24.50, type: "expense", category: "Transport" },
  { id: 4, title: "Starbucks", date: "Yesterday", amount: -12.40, type: "expense", category: "Food" },
  { id: 5, title: "Stock Dividend", date: "Mon, 12th", amount: 145.20, type: "income", category: "Investments" },
];

export const contacts = [
    { id: 1, name: "Sarah", avatar: "S" },
    { id: 2, name: "Mike", avatar: "M" },
    { id: 3, name: "Dad", avatar: "D" },
    { id: 4, name: "Alice", avatar: "A" },
    { id: 5, name: "Tom", avatar: "T" },
];

export const markets = [
    { symbol: "BTC", name: "Bitcoin", price: 64230.50, change: +2.4 },
    { symbol: "ETH", name: "Ethereum", price: 3450.20, change: -1.2 },
    { symbol: "SOL", name: "Solana", price: 145.80, change: +5.7 },
    { symbol: "TSLA", name: "Tesla", price: 240.50, change: +0.8 },
];
